// extracted by mini-css-extract-plugin
export default {"isFixed":"tnc-module__isFixed__2s-7n","container":"tnc-module__container__UM0Nb"};